import React from 'react';

import PresetGroupButton from '../../../../components/grid-header/add-preset-group';

import { useProductContext } from '../product-context';

export default () => {
  const { selectedProductIds } = useProductContext();

  return <PresetGroupButton selectedIds={selectedProductIds} />;
};
